import React, { FC } from 'react';

import { Navigate, useLocation } from 'react-router-dom';

import router from '~/core/router';
import { useAppSelector } from '~/store/hooks/useAppSelector';
import { ProfileType } from '~/types/profile';

interface Props {
  Component: FC;
  checkAvailability?: (profile: ProfileType) => boolean;
}

const PrivateRoute: FC<Props> = ({ Component, checkAvailability }) => {
  const profile = useAppSelector((state) => state.profile);
  const signInPath = router.getSignInRoutePath();
  const { pathname, search } = useLocation();

  return profile.isLoggedIn ? (
    <>
      {checkAvailability ? (
        checkAvailability(profile) ? (
          <Component />
        ) : (
          <Navigate to={router.getDefaultPrivateRoutePath()} />
        )
      ) : (
        <Component />
      )}
    </>
  ) : (
    <Navigate
      to={signInPath}
      state={{
        from: pathname + (search ? search : ''),
      }}
    />
  );
};

export default PrivateRoute;
